/* globals $ */
import { getComponentLoader } from 'libs/ComponentLoader'

/* polyfills */
import '@webcomponents/template'

/* vendor dependencies */
import 'a11y_accordions' /* SEE BELOW */
import 'a11y_accordions/assets/css/aria.accordion.css'
import 'slick-carousel'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'picturefill'
import 'object-fit-images'

import 'jquery-ui/ui/core'
import 'jquery-ui/ui/position'
import 'jquery-ui/ui/widgets/selectmenu'
import 'jquery-ui/themes/base/core.css'
import 'jquery-ui/themes/base/selectmenu.css'

/* Global styles */
import '../styles/normalize.scss'
import '../styles/typography.scss'
import '../styles/layout.scss'
import '../styles/forms.scss'
import '../styles/accordion.scss'
import '../styles/jquery-ui.scss'
import '../styles/utility.scss'

/* Components */
import 'components/Account'
import 'components/AccountNavigation'
import 'components/Addresses'
import 'components/Breadcrumbs'
import 'components/Button'
import 'components/Cart'
import 'components/CartModal'
import 'components/CartPromotions'
import 'components/CompactResultsControls'
import 'components/FeaturedProducts'
import 'components/Header'
import 'components/Hero'
import 'components/HeroCarousel'
import 'components/ImageBrowser'
import 'components/MainMenu'
import 'components/MobileMenu'
import 'components/MobileResultsHeader'
import 'components/ProductInformation'
import 'components/ProductDetails'
import 'components/ProductCard'
import 'components/ProductCarousel'
import 'components/ProductRecommendations'
import 'components/ProductSearch'
import 'components/QuantityStepper'
import 'components/QuerySummary'
import 'components/RedirectModal'
import 'components/ResultsFilterModal'
import 'components/ResultsPagination'
import 'components/ResultSorting'
import 'components/SearchInput'
import 'components/SearchResults'
import 'components/SidebarFilters'
import 'components/StyleGuide'
import 'components/TestComponent'
import 'components/UtilityMenu'
import 'components/VariantOptionSelector'

/* Style-only components */
import 'components/ActiveFilterButton/styles.scss'
import 'components/Account/styles.scss'
import 'components/AnnouncementBar/styles.scss'
import 'components/CategoryCallout/styles.scss'
import 'components/CollectionTemplate/styles.scss'
import 'components/Checkout/styles.scss'
import 'components/ExternalCallout/styles.scss'
import 'components/Footer/styles.scss'
import 'components/Header/styles.scss'
import 'components/LoginTemplate/styles.scss'
import 'components/Page/styles.scss'
import 'components/PageNotFound/styles.scss'
import 'components/Password/styles.scss'
import 'components/ProductPrice/styles.scss'
import 'components/ProductTemplate/styles.scss'
import 'components/PromoItemCard/styles.scss'
import 'components/TagSelector/styles.scss'
import 'components/TextImage/styles.scss'
import 'components/FAQTemplate/styles.scss'

/* ugh. a11y accordion tab index fix. Gross. */
import 'libs/a11yAccordionTabIndex'
import 'libs/detectIE11'

/* Event constants */
export const PAGE_COMPONENTS_LOADED = 'main:page_components_loaded'

/* Main code */
$(function () {
  loadStore()
  loadProduct()
  loadCollectionSettings()
  loadCustomer()
  setExternalLinks()

  loadComponents()
})

function loadComponents () {
  const componentLoader = getComponentLoader()
  componentLoader.loadComponents()

  $(document).trigger(PAGE_COMPONENTS_LOADED)
}

function loadStore () {
  // this may need some adjusting
  const $storeJson = $('#StoreJson')
  window.store = $storeJson.length ? JSON.parse($storeJson.html()) : false
}

function loadProduct () {
  const $productJson = $('#ProductJson-product-template')
  window.product = $productJson.length ? JSON.parse($productJson.html()) : false
}

function loadCustomer () {
  const $customerJson = $('#CustomerJson')
  window.customer = $customerJson.length ? JSON.parse($customerJson.html()) : false
}

function loadCollectionSettings () {
  const $collectionSettingsJson = $('#CollectionSettings')
  window.collectionSettings = $collectionSettingsJson.length ? JSON.parse($collectionSettingsJson.html()) : false
}

function setExternalLinks () {
  // Recommended as per https://help.shopify.com/en/themes/customization/navigation/open-external-links-in-new-browser

  var links = document.links
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if ((links[i].hostname !== window.location.hostname) && (!links[i].hasAttribute('data-internal'))) {
      links[i].target = '_blank'
    }
  }
}
